<bs-digital-result-succeeded-pick-list>
    <div class="digital-result-succeeded-pick teaser-bet-result-pick" *ngFor="let pick of slip.picks">
        <div class="circle-overlay">
            <span class="theme-radio-off"></span>
        </div>
        <bs-digital-result-succeeded-pick
            [pick]="pick"
            [boostedOdds]="isSingleBetPick ? slip.boostedOdds : undefined"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [summary]="summaryViewModel"></bs-digital-result-succeeded-pick>
    </div>
</bs-digital-result-succeeded-pick-list>
<bs-digital-result-succeeded-teaser-info [teaserPoints]="teasedPoints" [picksCount]="slip.picks.length"></bs-digital-result-succeeded-teaser-info>
